// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","footerItem":"Footer_footerItem__CoBP4","footerLeft":"Footer_footerLeft__Izh62","footerRight":"Footer_footerRight__VJSbu"};